import { z } from "zod";
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema, NonNegativeIntegerSchema, SourceRefSchema, StorageRefSchema, UnknownRecordSchema } from "./source.js";
export const MoneySchema = z
    .object({
    amount: z.number().nonnegative(),
    currency: z.enum(["GBP", "EUR", "USD"]),
    sourceRefs: z.array(SourceRefSchema).min(1)
})
    .strict();
export const PointVectorSchema = z
    .object({
    ui: NonNegativeIntegerSchema,
    di: NonNegativeIntegerSchema,
    ao: NonNegativeIntegerSchema,
    do: NonNegativeIntegerSchema,
    relay: NonNegativeIntegerSchema
})
    .strict();
export const CatalogCapabilityStatusSchema = z.enum([
    "reviewed",
    "price_only",
    "capability_only",
    "needs_review"
]);
export const CatalogSupplySourceSchema = z.enum([
    "titan_supplied",
    "fabricated",
    "in_house",
    "third_party"
]);
export const CatalogSourceStatusSchema = z.enum(["known", "research-needed"]);
export const CatalogProductSchema = z
    .object({
    id: IdSchema,
    catalogReleaseId: IdSchema,
    partNo: NonEmptyStringSchema,
    aliases: z.array(NonEmptyStringSchema),
    family: NonEmptyStringSchema,
    description: NonEmptyStringSchema,
    supplySource: CatalogSupplySourceSchema,
    sourceStatus: CatalogSourceStatusSchema,
    price: MoneySchema.optional(),
    capabilities: z
        .object({
        points: PointVectorSchema,
        maxZones: NonNegativeIntegerSchema.optional(),
        protocols: z.array(NonEmptyStringSchema),
        roles: z.array(NonEmptyStringSchema),
        primaryApplication: NonEmptyStringSchema.optional(),
        isPreferred: z.boolean(),
        notes: z.array(NonEmptyStringSchema)
    })
        .strict(),
    capabilityStatus: CatalogCapabilityStatusSchema,
    datasheetUrl: z.string().url().optional(),
    sourceRefs: z.array(SourceRefSchema).min(1),
    metadata: UnknownRecordSchema
})
    .strict();
export const CatalogReleaseSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    version: NonEmptyStringSchema,
    name: NonEmptyStringSchema,
    status: z.enum(["draft", "active", "superseded", "retired"]),
    sourceRefs: z.array(SourceRefSchema).min(1),
    sourceArtifacts: z.array(StorageRefSchema),
    productCount: NonNegativeIntegerSchema,
    capabilityReviewedCount: NonNegativeIntegerSchema,
    warnings: z.array(NonEmptyStringSchema),
    createdAt: IsoTimestampSchema,
    activatedAt: IsoTimestampSchema.optional()
})
    .strict();
//# sourceMappingURL=catalog.js.map